// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"ddbdf057","436":"58ef2a69"}[chunkId] + ".chunk.js";
};